export default {
  title: 'Reward points earned',
  points_one: '+1 point',
  points_other: '+{{count}} points',
};
